import { useState } from 'react';
import { Button, Form, Input, Alert } from 'antd';
import styled from 'styled-components';

const StyledAlert = styled(Alert)`
    margin-bottom: 32px;
`;

const StyledForm = styled(Form)`
    margin: 24px 0;
`;

const ChangePasswordModal = ({ updateInfo, showName, showCode }) => {
    const [form] = Form.useForm();
    const [error, setError] = useState(null);

    const onFinish = ({ password, name, code, mail }) => {
        updateInfo({ password, name, code, mail }).catch((err) =>
            setError(err)
        );
    };

    return (
        <StyledForm
            form={form}
            name="register"
            labelCol={{ xs: { span: 24 }, sm: { span: 7 } }}
            wrapperCol={{ xs: { span: 24 }, sm: { span: 17 } }}
            onFinish={onFinish}
            scrollToFirstError
        >
            {error && <StyledAlert message={error.message} type="error" />}

            {showCode && (
                <>
                    <Form.Item
                        name="mail"
                        label="E-mail"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your e-mail!',
                            },
                        ]}
                    >
                        <Input.Search
                            enterButton="Send code"
                            onSearch={showCode.sendCode}
                        />
                    </Form.Item>
                    <Form.Item
                        name="code"
                        label="Code"
                        rules={[
                            {
                                required: true,
                                message: 'Please input code from e-mail!',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                </>
            )}

            <Form.Item
                name="password"
                label="New Password"
                rules={[
                    {
                        required: true,
                        message: 'Please input your password!',
                    },
                    {
                        pattern: /[a-z]/,
                        message: 'Password must contain a lower case letter!',
                    },
                    {
                        pattern: /[A-Z]/,
                        message: 'Password must contain a upper case letter!',
                    },
                    {
                        pattern: /[0-9]/,
                        message: 'Password must contain a number!',
                    },
                    {
                        pattern: /[$*.{}()?"!@#%&,><':;|_~`+=[^/\\\]-]/,
                        message: 'Password must contain a special character!',
                    },
                    {
                        min: 20,
                        message:
                            'Password has to be at least 20 characters long!',
                    },
                ]}
                hasFeedback
            >
                <Input.Password />
            </Form.Item>

            <Form.Item
                name="confirm"
                label="Confirm Password"
                dependencies={['password']}
                hasFeedback
                rules={[
                    {
                        required: true,
                        message: 'Please confirm your password!',
                    },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!value || getFieldValue('password') === value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(
                                new Error(
                                    'The two passwords that you entered do not match!'
                                )
                            );
                        },
                    }),
                ]}
            >
                <Input.Password />
            </Form.Item>

            <Form.Item
                wrapperCol={{
                    xs: {
                        span: 24,
                        offset: 0,
                    },
                    sm: {
                        span: 16,
                        offset: 8,
                    },
                }}
            >
                <Button type="primary" htmlType="submit">
                    Change password
                </Button>
            </Form.Item>
        </StyledForm>
    );
};

export default ChangePasswordModal;
